import { render, staticRenderFns } from "./MikrowavPreview.vue?vue&type=template&id=2c5c8764&scoped=true&"
import script from "./MikrowavPreview.vue?vue&type=script&lang=js&"
export * from "./MikrowavPreview.vue?vue&type=script&lang=js&"
import style0 from "./MikrowavPreview.vue?vue&type=style&index=0&id=2c5c8764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c8764",
  null
  
)

export default component.exports